import React, {forwardRef, useImperativeHandle, useState} from 'react';
import PropTypes from 'prop-types';
import { Modal} from 'antd';

import JobLogsList from "@/page/admin/JobsPage/JobLogsPage/JobLogsList";

const JobLogsModal = forwardRef(({modalTitle}, ref) => {

    const [visible, setVisible] = useState(false);
    const [submiting, setSubmiting] = useState(false);

    function showModal() {
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
        setSubmiting(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));


    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            width={1200}
            title={modalTitle}
            visible={visible}
            onCancel={closeModal}
            onOk={closeModal}
            okButtonProps={{loading: submiting}}
        >
            <JobLogsList/>

        </Modal>
    );
});

JobLogsModal.displayName = 'JobLogsModal';

JobLogsModal.propTypes = {
    modalTitle: PropTypes.string,
};

export default JobLogsModal;
